import type { ReactNode } from 'react';
import { RendererProvider, ThemeProvider } from 'react-fela';
import { Provider as StoreProvider } from 'react-redux';
import { Router } from 'react-router-dom';
import { CompatRouter } from 'react-router-dom-v5-compat';
import { PersistGate } from 'redux-persist/integration/react';

import { ErrorBoundary } from '@/components/ErrorBoundary';
import { AuthProvider } from '@/modules/auth/components';
import { LocalizationsProvider } from '@/modules/localizations';
import { initSentry } from '@/modules/sentry/init';
import { ServiceWorkerLoader } from '@/modules/service-worker/components';

import { createRenderer } from '../modules/fela';
import { history, persistor, store } from '../modules/redux';
import { QueryProvider } from './QueryProvider';

initSentry();

const { renderer, theme } = createRenderer();

export interface CoreProps {
    children: ReactNode;
}

export const Core = ({ children }: CoreProps) => (
    <StoreProvider store={store}>
        <PersistGate persistor={persistor}>
            <RendererProvider renderer={renderer}>
                <ThemeProvider theme={theme}>
                    <Router history={history}>
                        <CompatRouter>
                            <LocalizationsProvider>
                                <QueryProvider>
                                    <ServiceWorkerLoader />
                                    <AuthProvider>
                                        <ErrorBoundary>{children}</ErrorBoundary>
                                    </AuthProvider>
                                </QueryProvider>
                            </LocalizationsProvider>
                        </CompatRouter>
                    </Router>
                </ThemeProvider>
            </RendererProvider>
        </PersistGate>
    </StoreProvider>
);
